
<div class="message-log snack" *ngIf="msg" [ngStyle]="msg.style" [ngClass]="[this.displayMode.Idle,this.displayMode.In,msg.cssClass]"
  (animationend)="onMsg1ShowEnd()" #msgdiv>
    <div [ngClass]="msg.cssClass" class="msg-type"></div>
    <div class="snack-content" style="flex-grow: 1;">{{msg.content}}</div>
</div>
<div class="message-log snack" *ngIf="msg2" [ngStyle]="msg2.style" [ngClass]="[this.displayMode.Idle,msg2.cssClass]"
  (animationend)="onMsg2ShowEnd()" #msgdiv2>
    <div [ngClass]="msg2.cssClass" class="msg-type"></div>
    <div class="snack-content" style="flex-grow: 1;">{{msg2.content}}</div>
</div>

